module.exports = __webpack_public_path__ + "assets/img/login_bg.1c8c834d.png";